/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_FaqInputs */

const et_nav_faq = /** @type {(inputs: Nav_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KKK`)
};

const en_nav_faq = /** @type {(inputs: Nav_FaqInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FAQ`)
};

/**
* | output |
* | --- |
* | "FAQ" |
*
* @param {Nav_FaqInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_faq = /** @type {((inputs?: Nav_FaqInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_FaqInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_nav_faq(inputs)
	return en_nav_faq(inputs)
});